export default {
  watch: {
    reviews(newReviews, oldReviews) {
      if (!oldReviews?.length) return;

      const oldReviewIds = new Set(oldReviews.map(({ id }) => id));
      const firstNewReview = newReviews.filter(
        ({ id }) => !oldReviewIds.has(id)
      )[0];
      if (!firstNewReview) return;

      this.$nextTick(() => {
        const reviewBlock = this.$refs[`review-block-${firstNewReview.id}`];
        if (!reviewBlock) return;

        const element = reviewBlock[0];
        element.setAttribute('tabindex', '0');

        const handleBlur = () => {
          element.removeAttribute('tabindex');
          element.removeEventListener('blur', handleBlur);
        };

        element.addEventListener('blur', handleBlur);
        element.focus({ preventScroll: true });
      });
    }
  }
};
